<script setup lang="ts">
import { computed } from 'vue'

import { navigate } from '../router'
import { useSession } from '../session'
import AppMark from './AppMark.vue'

defineProps<{
  compact?: boolean
}>()

const emit = defineEmits<{
  toggleTheme: []
}>()

const session = useSession()
const displayName = computed(
  () => session.state.user?.firstName
    || (session.state.user?.username ? `@${session.state.user.username}` : '')
    || 'Мой кабинет',
)

async function signOut(): Promise<void> {
  await session.logout()
  navigate('/login', true)
}
</script>

<template>
  <div class="app-frame" :class="{ 'app-frame--compact': compact }">
    <header class="topbar">
      <a href="/" class="brand" aria-label="GetSlides, на главную">
        <AppMark />
        <span>GetSlides</span>
      </a>

      <nav class="topbar__actions" aria-label="Панель пользователя">
        <slot name="actions"></slot>
        <button
          type="button"
          class="icon-button theme-toggle"
          aria-label="Переключить тему"
          title="Переключить тему"
          @click="emit('toggleTheme')"
        >
          <span class="theme-toggle__sun">☀</span>
          <span class="theme-toggle__moon">☾</span>
        </button>
        <details v-if="session.state.authenticated" class="user-menu">
          <summary class="user-chip">{{ displayName }}</summary>
          <div class="user-menu__popover surface-card">
            <p v-if="session.state.kind === 'user' && session.state.user" class="muted">
              Использовано: {{ session.state.user.quotaUsed }}
            </p>
            <button type="button" class="text-button danger" @click="signOut">
              Выйти
            </button>
          </div>
        </details>
      </nav>
    </header>

    <main class="app-content" :class="{ 'app-content--compact': compact }">
      <slot></slot>
    </main>
  </div>
</template>
